import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=e7596a52"
import script from "./CartView.vue?vue&type=script&lang=js"
export * from "./CartView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconsTrash: require('/home/node/app/components/ui/icons/trash.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerCart: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCart.js').default})
